import clsx from 'clsx';
import { memo } from 'react';
import { AppBar, styled, useMediaQuery, useTheme } from '@mui/material';

import { Icon } from 'app/main/components';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import NavbarToggleButton from 'app/fuse-layouts/shared-components/NavbarToggleButton';
import Navigation from 'app/fuse-layouts/shared-components/Navigation';
import UserNavbarHeader from 'app/fuse-layouts/shared-components/UserNavbarHeader';

const Root = styled('div')(({ theme }) => ({
	backgroundColor: theme.palette.background.default,
	color: theme.palette.text.primary,

	'& .NavbarMobileLayout3-content': {
		overflowX: 'hidden',
		overflowY: 'auto',
		WebkitOverflowScrolling: 'touch',
		background:
			'linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 30%), linear-gradient(rgba(0, 0, 0, 0.25) 0, rgba(0, 0, 0, 0) 40%)',
		backgroundRepeat: 'no-repeat',
		backgroundSize: '100% 40px, 100% 10px',
		backgroundAttachment: 'local, scroll'
	}
}));

function NavbarMobileLayout3({ className }: { className?: string }) {
	const theme = useTheme();
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

	return (
		<Root className={clsx('flex h-full flex-col overflow-hidden', className)}>
			<AppBar
				color="primary"
				position="static"
				className="flex h-48 min-h-48 shrink flex-row items-center px-12 shadow-0 md:h-64 md:min-h-64"
			>
				<div className="mx-8 flex flex-1">
					<Logo />
				</div>

				{isLgUp ? (
					<NavbarToggleButton className="h-40 w-40 p-0" />
				) : (
					<NavbarToggleButton className="h-40 w-40 p-0">
						<Icon icon={theme.direction === 'ltr' ? 'arrow-left' : 'arrow-right'} />
					</NavbarToggleButton>
				)}
			</AppBar>

			<FuseScrollbars
				className="NavbarMobileLayout3-content"
				option={{ suppressScrollX: true, wheelPropagation: false }}
			>
				<UserNavbarHeader />

				<Navigation layout="vertical" />
			</FuseScrollbars>
		</Root>
	);
}

export default memo(NavbarMobileLayout3);
